import type { VideoTrialStatusMessageProps } from './index.types';
import { Icon } from 'Components/shared/Icon';
import * as React from 'react';

/**
 * Renders Video Trial status message.
 *
 * @param message - Text to display next to the info icon.
 */
export const VideoTrialStatusMessage: React.FC<VideoTrialStatusMessageProps> = ({ message }) => (
  <div className="mt-3 flex gap-1 text-foreground [.private-room_&]:mt-0">
    <Icon icon="info-filled" size="tiny" className="!text-primary" />
    <span className="text-subtitles">{message}</span>
  </div>
);